import quoteRequest from './quote-request'

export default {
  getDraftQuotePrice: {
    method: 'post',
    url: '/quote/draft'
  },
  getQuoteDataEdit: {
    method: 'get',
    url: '/quote/data-edit/ID'
  },
  editStatus: {
    method: 'put',
    url: '/quote/update-status/ID'
  },
  editQuote: {
    method: 'put',
    url: '/quote/edit/ID'
  },
  approveStatusMarkup: {
    method: 'put',
    url: '/quote/ID/approve-markup'
  },
  rejectStatusMarkup: {
    method: 'put',
    url: '/quote/ID/reject-markup'
  },
  checkAllocationTrip: {
    method: 'post',
    url: '/quote/check-allocation-trip/ID'
  },
  create: {
    method: 'post',
    url: '/quote/create'
  },
  createQuoteByQuoteRequest: {
    method: 'post',
    url: '/quote/create-by-quote-request'
  },
  get: {
    method: 'post',
    url: '/quote'
  },
  detail: {
    method: 'get',
    url: '/quote/ID'
  },
  getQuotePrice: {
    method: 'get',
    url: '/quote/price/quoteRequestId'
  },
  find: {
    method: 'post',
    url: '/quote/find?key=KEY'
  },
  xlsx: {
    method: 'get',
    url: '/quote/excel/ID'
  },
  pdf: {
    method: 'get',
    url: '/quote/pdf/ID'
  },
  sendEmail: {
    method: 'get',
    url: '/quote/send-email-for-customer/ID'
  },
  delete: {
    method: 'delete',
    url: '/quote'
  },
  archive: {
    method: 'delete',
    url: '/quote/archive'
  },
  restore: {
    method: 'put',
    url: '/quote/restore'
  },
  customer: {
    method: 'get',
    url: '/quote/customer/customerId'
  },
  resycn: {
    method: 'post',
    url: '/quote/ID/resync'
  },
  quoteRequest
}
